export default "__VITE_ASSET__9b836090__"